module.exports = __webpack_public_path__ + "static/media/services-img3.18d6a88f.svg";